import { Component, OnInit, AfterViewInit , ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule,HttpParams } from '@angular/common/http';
import * as Papa from 'papaparse';

import { ActivatedRoute,Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { environment } from '../environments/environment';
import { ApiService } from '../utility/api.service';


@Component({
  selector: 'app-view-files',
  imports: [CommonModule,HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule],
  templateUrl: './view-files.component.html',
  styleUrl: './view-files.component.css'
})
export class ViewFilesComponent implements OnInit, AfterViewInit {
  csvRecords: any[] = [];
  columns: string[] = [];
 
  UniqueBUs: { BU: string, count: number }[] = [];
  buName: string | null = '';

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  data: any[] = [];
  displayedColumns: string[] = [];

  error: string | null = null;
  showProgress = false;

  lastModified: string | null = null;

  
  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit() {
    const key = this.route.snapshot.paramMap.get('key') || 'publish';
    const filename = this.route.snapshot.paramMap.get('filename') || 'accounts';
    const url = `${environment.cacheUrl}/${key}/${filename}.csv`

    console.log(key)
    console.log(filename)

    this.showProgress = true;

    this.api.getAccessToken$().subscribe({
    next: (token: string) => {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`
      });

      this.http.get(url, { headers, responseType: 'text' }).subscribe({
        next: csvData => {
          Papa.parse(csvData, {
            header: true,
            complete: (results) => {
              this.csvRecords = results.data;
              if (this.csvRecords.length) {
                this.displayedColumns = Object.keys(this.csvRecords[0]);
                this.data = this.csvRecords;
                this.dataSource.data = this.csvRecords;
                this.showProgress = false;
                const buCountObj = this.data.reduce((BU: { [key: string]: number }, curr) => {
                  BU[curr.BU] = (BU[curr.BU] || 0) + 1;
                  return BU;
                }, {});
                this.UniqueBUs = Object.entries(buCountObj).map(([BU, count]) => ({ BU, count }));
                console.log(this.UniqueBUs)
              }
            }
          });
        },
        error: err => {
          this.showProgress = false;
          this.error = err.message;
        }
      });
    },
    error: err => {
      this.showProgress = false;
      this.error = err.message;
    }
  });
}

  onAccountChange(prefix: string | null) {
  this.buName = prefix; 
  
  if (!prefix) {
    // Show all data
    this.dataSource.data = this.data;
  } else {
    this.dataSource.data = this.data.filter(row =>
      row.BU && row.BU === prefix
    );
  }
}
}
